import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

import { getUserVisibleOrDefaultExceptionMessage } from '@paragon/client-tools';
import { enqueueError } from '@paragon/notification-tools';

import { useAppMonitor } from '../../../monitor';
import { saveEntireLayout } from '../../../store/actions/editorActions';
import {
  getAllLayoutUserDistanceDimensionsCount,
  getLocalLayoutUserDistanceDimensionsCount,
} from '../../../store/selectors/layoutDataSelectors';
import { layoutSlice } from '../../../store/slices/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from './ToolbarIconButton';

export function LayoutDimensionModeToolbarButtons() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const inProjectContext = useAppSelector((state) => state.application.openContext?.type === 'project');
  const localUserDistanceDimensionsCount = useAppSelector(getLocalLayoutUserDistanceDimensionsCount);
  const userDistanceDimensionsCount = useAppSelector(getAllLayoutUserDistanceDimensionsCount);

  if (!inProjectContext) return null;

  return (
    <>
      <ToolbarIconButton
        icon={<SaveIcon />}
        title="Save user dimensions"
        onClick={() => {
          try {
            dispatch(layoutSlice.actions.userDistanceDimensionsSaved());
            dispatch(saveEntireLayout());
            monitor.recordInteraction('"Save User Dimensions" button clicked');
          } catch (error) {
            dispatch(enqueueError(getUserVisibleOrDefaultExceptionMessage(error, 'Failed to save user dimensions.')));
          }
        }}
        disabled={localUserDistanceDimensionsCount === 0}
      />

      <ToolbarIconButton
        icon={<DeleteIcon />}
        title="Delete newest user dimension"
        onClick={() => {
          try {
            dispatch(layoutSlice.actions.userDistanceDimensionDeleted());
            // note that this will be the count before deletion
            if (localUserDistanceDimensionsCount === 0) {
              dispatch(saveEntireLayout());
            }

            monitor.recordInteraction('"Delete Newest User Dimension" button clicked');
          } catch (error) {
            dispatch(
              enqueueError(getUserVisibleOrDefaultExceptionMessage(error, 'Failed to delete newest user dimension.')),
            );
          }
        }}
        disabled={userDistanceDimensionsCount === 0}
      />
    </>
  );
}
